<!-- start banner Area -->
<section class="top-banner mb-4">
    <div class="top-banner-img" style="">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h1 style="padding: 30px 0px 0px 0px !important;"> Diplômes et Formations </h1>
                    <p class="text-white link-nav"><a [routerLink]="['/accueil', 'candidat']"
                            style="color: #ff5a00 !important">Accueil</a> <span class="lnr lnr-arrow-right"></span>
                        <span> diplômes et formation</span>
                    </p>

                </div>
            </div>
        </div>
    </div>
</section>
<!-- End banner Area -->

<section class="service-area section-gap" id="service">
    <div class="container mb-5">
        <!-- Taux de remplissage (progress bar) -->
        <!-- <div class="col-md-12 mb-3">
            <div class="label-progress">Taux de remplissage de vos informations</div>
            <div class="progress">
                <div [ngClass]="{'progress-bar bg-danger text-white': totalFillingRate < 50, 'progress-bar bg-warning text-dark' : totalFillingRate < 100, 'progress-bar bg-success text-center text-white' : totalFillingRate === 100 }"
                    role="progressbar" [ngStyle]="{'width': totalFillingRate + '%', 'text-align': 'center'}"
                    aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">{{ totalFillingRate }}%</div>
            </div>
        </div> -->
        <div class="row mb-4">
            <div class="col-md-12 ">
                <div class="card"
                    style=" box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);border-radius: 15px;">
                    <div class="card-body">
                        <p>Profil complèté à {{ totalFillingRate }}%</p>
                        <div class="progress">
                            <div [ngClass]="{'progress-bar bg-danger text-white': totalFillingRate < 50, 'progress-bar bg-warning text-dark' : totalFillingRate < 100, 'progress-bar bg-success text-center text-white' : totalFillingRate === 100 }"
                                role="progressbar" [ngStyle]="{'width': totalFillingRate + '%', 'text-align': 'center'}"
                                aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">{{ totalFillingRate }}%</div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <section class="row justify-content-center">
            <!-- Button to go back apply job -->
            <div class="col-md-4 mb-3" *ngIf="showBtnToGoApplyJob">
                <a routerLink="/postuler/{{ jobIDToApply }}" class="btn btn-danger" style="color: white;">Retour vers la
                    page d'emploi</a>
            </div>
        </section>
        <section class="">
            <div class="row mb-5">
                <div class="col-md-9 ">
                    <div class="card"
                        style=" box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);">
                        <div class="card-body">




                            <h3 class="mt-3 mb-5" style="text-align: center; font-weight: bold;">Diplômes & formations
                            </h3>

                            <div id="trainingBlock" style="display: ">
                                <!-- Liste des ajouts -->
                                <div class="form-group mt-5" style="width: 100%; overflow: auto;">
                                    <table class="table table-bordered">
                                        <tr>
                                            <th>Formation</th>
                                            <th>Université</th>
                                            <th>Periode</th>
                                            <th>Niveau d'étude</th>
                                            <!-- <th>Diplôme</th> -->
                                            <th>Action</th>
                                        </tr>
                                        <tr *ngFor="let candidateTraining of candidateTrainingList">
                                            <td>{{ candidateTraining.getTrainings()['libelle'] }}</td>
                                            <td>{{ candidateTraining.getUniversity() }}</td>
                                            <td>{{ candidateTraining.getPeriodStart() }} à <span
                                                    *ngIf="candidateTraining.getInProgress()">ce
                                                    jour</span><span *ngIf="!candidateTraining.getInProgress()">{{
                                                    candidateTraining.getPeriodEnd()
                                                    }}</span></td>
                                            <td>{{ candidateTraining.getLevelOfStudy() }}</td>
                                            <!-- <td><a *ngIf="candidateTraining.getDiplomaPath() != ''"
                                            [href]="candidateTraining.getDiplomaPath()" target="_blank"
                                            class="btn btn-success">Voir</a></td>-->
                                            <td>

                                                <span (click)="editTraining(candidateTraining)"
                                                    class="btn btn-info a-btn-slide-text mr-1">
                                                    <span class="glyphicon glyphicon-edit" aria-hidden="true">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                            fill="currentColor" class="bi bi-pen" viewBox="0 0 16 16">
                                                            <path
                                                                d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001zm-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708l-1.585-1.585z" />
                                                        </svg>
                                                    </span>
                                                </span>

                                                <a *ngIf="candidateTraining.getDiplomaPath() != ''"
                                                    [href]="candidateTraining.getDiplomaPath()" target="_blank"
                                                    class="btn btn-primary a-btn-slide-text mr-1"><svg
                                                        xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                        fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16">
                                                        <path
                                                            d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                                                        <path
                                                            d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                                                    </svg></a>
                                                <span class="btn btn-danger a-btn-slide-text"
                                                    (click)="removeTraining(candidateTraining.getId())">
                                                    <span class="glyphicon glyphicon-remove" aria-hidden="true"><svg
                                                            xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                            fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                                                            <path
                                                                d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                                                            <path fill-rule="evenodd"
                                                                d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                                                        </svg></span>
                                                </span>

                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>

                            <h3 class="mt-4 mb-4" style="text-align: center; font-weight: bold;">Ajouter vos Diplômes &
                                formations
                            </h3>


                            <form [formGroup]="trainingsForm" (ngSubmit)="onSubmitTrainingForm()">
                                <div class="row">
                                    <div class="form-group col-md-4">
                                        <label for="training">Domaine <span class="star-style">**</span></label>
                                        <select class="form-control h-40px" id="training" formControlName="training_id">
                                            <option value="" selected>Selectionner...</option>
                                            <option [value]="training.getId()" *ngFor="let training of trainingList">{{
                                                training.getLibelle() }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="form-group col-md-4">
                                        <label for="level_of_study">Niveau d'études <span
                                                class="star-style">**</span></label>
                                        <select class="form-control" id="level_of_study"
                                            formControlName="level_of_study">
                                            <option value="">Selectionner...</option>
                                            <option value="Secondaire">Secondaire</option>
                                            <option value="Terminal">Terminal</option>
                                            <option value="Formation professionnelle">Formation professionnelle
                                            </option>
                                            <option value="Baccalauréat">Baccalauréat</option>
                                            <option value="Universitaire sans diplôme">Universitaire sans diplôme
                                            </option>
                                            <option value="BAC + 2">BAC + 2</option>
                                            <option value="Licence(BAC + 3)">Licence(BAC + 3)</option>
                                            <option value="Master 1(BAC + 4)">Master 1(BAC + 4)</option>
                                            <option value="Master 2(BAC + 5)">Master 2(BAC + 5)</option>
                                            <option value="Doctorat(BAC + 7)">Doctorat(BAC + 7)</option>
                                        </select>
                                    </div>
                                    <div class="form-group col-md-4">
                                        <label for="university">Université <span class="star-style">**</span></label>
                                        <input type="text" class="form-control h-40px text-uppercase" id="university"
                                            formControlName="university">
                                    </div>

                                </div>
                                <div class="row">
                                    <div class="form-group col-md-4">
                                        <label for="periodStartTraining">Date début <span
                                                class="star-style">**</span></label>
                                        <select class="form-control" id="periodStartTraining"
                                            formControlName="month_start">
                                            <option value="">Selectionner...</option>
                                            <option value="01">Janvier</option>
                                            <option value="02">Février</option>
                                            <option value="03">Mars</option>
                                            <option value="04">Avril</option>
                                            <option value="05">Mai</option>
                                            <option value="06">Juin</option>
                                            <option value="07">Juillet</option>
                                            <option value="08">Aôut</option>
                                            <option value="09">Septembre</option>
                                            <option value="10">Octobre</option>
                                            <option value="11">Novembre</option>
                                            <option value="12">Décembre</option>
                                        </select>
                                    </div>
                                    <div class="form-group col-md-4">
                                        <label for="periodStartTraining">Année <span
                                                class="star-style">**</span></label>
                                        <!-- <input type="number" step="1" min="1900" class="form-control h-40px" > -->
                                        <select class="form-control" id="year" formControlName="year_start">

                                            <option value="1984">1984</option>
                                            <option value="1985">1985</option>
                                            <option value="1986">1986</option>
                                            <option value="1987">1987</option>
                                            <option value="1988">1988</option>
                                            <option value="1989">1989</option>
                                            <option value="1990">1990</option>
                                            <option value="1991">1991</option>
                                            <option value="1992">1992</option>
                                            <option value="1993">1993</option>
                                            <option value="1994">1994</option>
                                            <option value="1995">1995</option>
                                            <option value="1996">1996</option>
                                            <option value="1997">1997</option>
                                            <option value="1998">1998</option>
                                            <option value="1999">1999</option>
                                            <option value="2000">2000</option>
                                            <option value="2001">2001</option>
                                            <option value="2002">2002</option>
                                            <option value="2003">2003</option>
                                            <option value="2004">2004</option>
                                            <option value="2005">2005</option>
                                            <option value="2006">2006</option>
                                            <option value="2007">2007</option>
                                            <option value="2008">2008</option>
                                            <option value="2009">2009</option>
                                            <option value="2010">2010</option>
                                            <option value="2011">2011</option>
                                            <option value="2012">2012</option>
                                            <option value="2013">2013</option>
                                            <option value="2014">2014</option>
                                            <option value="2015">2015</option>
                                            <option value="2016">2016</option>
                                            <option value="2017">2017</option>
                                            <option value="2018">2018</option>
                                            <option value="2019">2019</option>
                                            <option value="2020">2020</option>
                                            <option value="2021">2021</option>
                                            <option value="2022">2022</option>
                                            <option value="2023">2023</option>
                                        </select>
                                    </div>
                                    <div class="form-group col-md-4 my-auto">
                                        <input type="checkbox" id="trainingInProgress"
                                            (click)="functionsService.showOrHideEndDate('blockPeriodEndTraining', 'trainingInProgress', true)">
                                        <label for="trainingInProgress" style="margin-left: 5px"
                                            (click)="functionsService.showOrHideEndDate('blockPeriodEndTraining', 'trainingInProgress', false)">En
                                            cours</label>
                                    </div>
                                </div>
                                <div class="row" id="blockPeriodEndTraining">
                                    <div class="form-group col-md-4" id="blockPeriodEndTraining">
                                        <label for="periodEndTraining">Date Fin</label>
                                        <select class="form-control" id="periodEndTraining" formControlName="month_end">
                                            <option value="">Selectionner...</option>
                                            <option value="01">Janvier</option>
                                            <option value="02">Février</option>
                                            <option value="03">Mars</option>
                                            <option value="04">Avril</option>
                                            <option value="05">Mai</option>
                                            <option value="06">Juin</option>
                                            <option value="07">Juillet</option>
                                            <option value="08">Aôut</option>
                                            <option value="09">Septembre</option>
                                            <option value="10">Octobre</option>
                                            <option value="11">Novembre</option>
                                            <option value="12">Décembre</option>
                                        </select>
                                    </div>
                                    <div class="form-group col-md-4">
                                        <label for="periodEndTraining">Année</label>
                                        <!-- <input type="number" step="1" min="1900" id="periodEndTraining"
                                    class="form-control h-40px" formControlName="year_end"> -->
                                        <select class="form-control" id="year" formControlName="year_end">

                                            <option value="1984">1984</option>
                                            <option value="1985">1985</option>
                                            <option value="1986">1986</option>
                                            <option value="1987">1987</option>
                                            <option value="1988">1988</option>
                                            <option value="1989">1989</option>
                                            <option value="1990">1990</option>
                                            <option value="1991">1991</option>
                                            <option value="1992">1992</option>
                                            <option value="1993">1993</option>
                                            <option value="1994">1994</option>
                                            <option value="1995">1995</option>
                                            <option value="1996">1996</option>
                                            <option value="1997">1997</option>
                                            <option value="1998">1998</option>
                                            <option value="1999">1999</option>
                                            <option value="2000">2000</option>
                                            <option value="2001">2001</option>
                                            <option value="2002">2002</option>
                                            <option value="2003">2003</option>
                                            <option value="2004">2004</option>
                                            <option value="2005">2005</option>
                                            <option value="2006">2006</option>
                                            <option value="2007">2007</option>
                                            <option value="2008">2008</option>
                                            <option value="2009">2009</option>
                                            <option value="2010">2010</option>
                                            <option value="2011">2011</option>
                                            <option value="2012">2012</option>
                                            <option value="2013">2013</option>
                                            <option value="2014">2014</option>
                                            <option value="2015">2015</option>
                                            <option value="2016">2016</option>
                                            <option value="2017">2017</option>
                                            <option value="2018">2018</option>
                                            <option value="2019">2019</option>
                                            <option value="2020">2020</option>
                                            <option value="2021">2021</option>
                                            <option value="2022">2022</option>
                                            <option value="2023">2023</option>
                                        </select>
                                    </div>

                                </div>
                                <div class="row">
                                    <div class="form-group col-md-4">
                                        <label for="diploma">Attestation <span
                                                style="font-size: 10px; font-weight: 700;">(pdf,
                                                < 1Mo)</span>
                                        </label>
                                        <span class="form-control h-40px btn btn-success"
                                            (click)="chooseDiploma()">Joindre
                                            fichier</span><span *ngIf="diplomaFile != null"
                                            style="font-size: 10px; font-weight: 700; color: green">
                                            Super! Fichier
                                            joint</span>
                                    </div>
                                </div>
                                <button type="submit" class="primary-btn text-white" [disabled]="trainingsForm.invalid"
                                    *ngIf="!trainingIsLoading">Ajouter</button>
                                <p class="text-danger" style="padding-top: 15px; margin-left: 15px;"
                                    *ngIf="trainingIsLoading">
                                    Veuillez
                                    patienter...
                                </p>
                            </form>

                            <div class="row justify-content-center mt-5 mb-5">

                                <a routerLink="/postuler/{{ jobIDToApply }}" class="btn btn-warning mr-2">Retour vers la
                                    page
                                    d'emploi</a>

                                <button class="btn btn-outline-warning col-md-2 mr-2"
                                    routerLink="/candidat-infos">Retour
                                </button>
                                <button class="btn btn-primary col-md-6" routerLink="/candidat-certificates"> Cliquez
                                    ici pour
                                    ajouter
                                    vos certificats
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <app-articles></app-articles>
                </div>
            </div>
        </section>

    </div>
</section>